import moment from 'moment-timezone';

/** Business timezone for pickup / delivery — wall clocks must match across checkout, customer, and admin. */
export const SWISS_TZ = 'Europe/Zurich';

/**
 * @param {Date|string|number} calendarDate — date picker value; y/m/d taken as the calendar day labels
 * @param {number} hour — 0–23 in Swiss local time
 * @param {number} [minute=0]
 * @returns {number} UTC millis (same shape as Date#setHours return value for JSON payloads)
 */
export function zonedDateTimeMillis(calendarDate, hour, minute = 0) {
    const d = calendarDate instanceof Date ? calendarDate : new Date(calendarDate);
    return moment.tz(
        [d.getFullYear(), d.getMonth(), d.getDate(), hour, minute, 0, 0],
        SWISS_TZ
    ).valueOf();
}

/** Start of the given calendar day at 00:00 in Switzerland. */
export function calendarDayStartMillis(calendarDate) {
    return zonedDateTimeMillis(calendarDate, 0, 0);
}

export function formatInSwissTz(input, formatStr) {
    return moment(input).tz(SWISS_TZ).format(formatStr);
}
